import { useState,useMemo } from "react";
export const useSortableTable = (items, config = null) => {
    const [sortConfig, setSortConfig] = useState(config);
    
    const sortedItems = useMemo(() => {
      let sortableItems = [...items];
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          const valueA = a[sortConfig.key].toLowerCase();
          const valueB = b[sortConfig.key].toLowerCase();
          if (valueA < valueB) {return sortConfig.direction === "ascending" ? -1 : 1 }
          if (valueA > valueB) {return sortConfig.direction === "ascending" ? 1 : -1 }
          return 0;
        });
      }
      return sortableItems;
    }, [items, sortConfig]);
  
    const requestSort = key => {
      let direction = 'ascending';
      if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
        direction = 'descending'}
      setSortConfig({ key, direction });
    }
  
    return { items: sortedItems, requestSort };
  }